import { STATUS_BAD_REQUEST } from "../../models/httpsStatus";
import { AppDispatch } from "../../redux/index";
import {
  updateNotificationMessage,
  updateNotificationStatus,
} from "../../redux/states/notificationSlice";
import { deleteEmployeeSchedule } from "../../services/deletes";

export const deleteEmployeeScheduleAdapter = async (
  idSchedule: number,
  dispatch: AppDispatch,
  initialSchedules,
  setInitialSchedules: Function,
  setIsSubmitDisabled: Function,
  setIsSubmitLoading: Function,
  reassignAffected?: boolean
): Promise<boolean> => {
  const updateNotification = (response: { data: string; status: number }) => {
    dispatch(updateNotificationMessage(response.data));
    dispatch(updateNotificationStatus(response.status));
  };

  setIsSubmitDisabled(true);
  setIsSubmitLoading(true);

  try {
    const removeScheduleById = (arr, idScheduleToRemove) => {
      return arr.map((day) => {
        return {
          ...day,
          scheduleList: day.scheduleList.filter((schedule) => {
            return schedule.idSchedule !== idScheduleToRemove;
          }),
        };
      });
    };

    if (!String(idSchedule).includes("static")) {
      const response: IResponse = await deleteEmployeeSchedule(
        idSchedule,
        reassignAffected
      );
      if (!response?.isSuccess || response.data == null) {
        // El borrado falló: avisar con el mensaje del backend y conservar la fila.
        updateNotification({
          data: response?.message || "No se pudo eliminar el horario.",
          status: response?.status || STATUS_BAD_REQUEST,
        });
        setIsSubmitLoading(false);
        return false;
      }
      updateNotification(response);
    }

    const newArray = removeScheduleById(initialSchedules, idSchedule);
    setInitialSchedules(newArray);
    setIsSubmitLoading(false);
    return true;
  } catch (error) {
    updateNotification({
      data: "Verifique que todos los horarios estén completos",
      status: STATUS_BAD_REQUEST,
    });
    setIsSubmitLoading(false);
    return false;
  }
};
